import Form from '@admin/components/form'
import T from '@admin/components/t'
import PropTypes from 'prop-types'
import tasks from './tasks'
import React from 'react'

class Request extends React.Component {

  static contextTypes = {
    modal: PropTypes.object
  }

  static propTypes = {
    advisor: PropTypes.object
  }

  _handleCancel = this._handleCancel.bind(this)
  _handleSuccess = this._handleSuccess.bind(this)

  render() {
    return <Form { ...this._getForm() } />
  }

  _getForm() {
    const { advisor } = this.props
    return {
      title: 't(Request Additional Information)',
      method: 'PATCH',
      action: `/api/admin/truevail/admin/advisors/${advisor.id}/configuration`,
      onCancel: this._handleCancel,
      onSuccess: this._handleSuccess,
      sections: [
        {
          fields: [
            { 
              label: 't(Requirements)', 
              name: 'configuration.requirements', 
              type: 'checkboxgroup', 
              options: tasks,
              valueKey: 'code',
              textKey: 'title',
              format: (task) => (
                <div className="token">
                  <strong><T text={ task.title } /></strong><br />
                  <T text={ task.description } />
                </div>
              )
            }
          ]
        }
      ]
    }
  }

  _handleCancel() {
    this.context.modal.close()
  }

  _handleSuccess() {
    this.context.modal.close()
  }

}

export default Request
